import { paymentsApi } from '../httpService';


const getClientProcessorSettings = async (clientId: number | string) => {
    try {
        return (await paymentsApi.get(`/api/v1/clients/${clientId}/processors/settings`, {
            //params: params
        })).data;
    } catch (error: any) {
        throw new Error("An unexpected Error");
    }
}


const createSetting = async (data: any) => {
    try {
        return (await paymentsApi.post(`/api/v1/processors/settings`, data)).data;
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            throw new Error(error.response.data.errors[0].message);
        }

        throw new Error("Sorry, there was a problem creating processor settings. Please try again later.");
    }
}



const updateSettings = async (clientId: number, settingsId: number, data: any) => {
    try {
        return (await paymentsApi.patch(`/api/v1/clients/${clientId}/processors/settings/${settingsId}`, data)).data;
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            throw new Error(error.response.data.errors[0].message);
        }

        throw new Error("Sorry, there was a problem creating processor settings. Please try again later.");
    }
}



const deleteSettings = async (clientId: number, settingsId: number) => {
    try {
        return (await paymentsApi.delete(`/api/v1/clients/${clientId}/processors/settings/${settingsId}`)).data;
    } catch (error: any) {
        throw new Error("An unexpected Error");
    }
}


export default {
    getClientProcessorSettings,
    createSetting,
    updateSettings,
    deleteSettings
}